(function () {
  'use strict';

  angular
    .module('app.category', [])

    /* @ngInject */
    .directive('categoryProducts', function () {
      return {
        restrict: 'A',
        scope: true,
        bindToController: {
          idCategory: '<',
          searchQuery: '@?',
          currentPage: '<',
          totalProducts: '<',
          nbPerPage: '<',
          maxPage: '<',
          sort: '@',
          sortTitle: '@',
          iScrollMaxPages: '<',
          device: '<',
          js: '@'
        },
        controllerAs: 'categoryCtrl',
        /* @ngInject */
        controller: ["$filter", "LoadService", function ($filter, LoadService) {
          var ctrl = this;

          // Init filters as it is async
          $filter('discount')(1, 'value');
          $filter('price')(1, 'value');

          ctrl.$onInit = function () {
            if (window.isBot || window.isCache) {
              ctrl.nbProducts = ctrl.totalProducts;
              return;
            }
            LoadService.getService('AsyncCategoryService', { ctrl: ctrl }, 'initModule');
          };
          ctrl.$onDestroy = function () {
            ctrl.api.busy = true;
          };
        }]
      };
    });

})();
